export default "__VITE_ASSET__Ba5Yp$bz__"